class FixBanner {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    var fixedBanner = $(".c-fixedBanner");
    var footer = $(".l-footer");

    if(fixedBanner) {
      // Closeボタンが押されたときの処理
      $(".c-fixedBanner__close").click(function() {
          fixedBanner.addClass("is-hidden");
      });
  
      // スクロール時の処理
      $(window).scroll(function() {
          var footerOffsetTop = footer.offset().top;
          var fixedBannerOffsetTop = fixedBanner.offset().top;
  
          // FixedBannerがFooterに到達したときの処理
          if (fixedBannerOffsetTop + fixedBanner.height() >= footerOffsetTop) {
              fixedBanner.addClass("is-hidden");
          }
      });
    }
  }
}


